import * as React from 'react';
import styled from 'styled-components';
import {
  Field,
  Checkbox,
  Button,
  Link,
} from '../../components';

// outer shell: centers everything
const Shell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  ${p => p.theme.global}

  .${(Checkbox as any).styledComponentId}{
    margin: 20px 0;
  }

  .${(Button as any).styledComponentId}{
    margin: 43px auto 56px;
    display: block;
    padding: 15px 0;
    min-width: 218px;
  }

  .${(Link as any).styledComponentId}{
    display: flex;
    text-align: center;
    margin: 0 auto;
    width: fit-content;
  }

`;

// visual panel (grid split or single-column)
const Panel = styled.section`
  min-width: 470px;
  max-width: 940px;
  width: 100%;
  min-height: 560px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0,0,0,0.25);
  background: ${p => p.theme.main};

  display: grid;
  grid-template-columns: clamp(470px, 50vw, 470px) 1fr;
`;

const FormPane = styled.div`
  background: ${p => p.theme.main};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 330px;
  padding: 75px 70px 96px;
`;

// put all the form spacing rules here, independent of component types
const FormCard = styled.div`
  width: 100%;
  max-width: 330px;

  /* generic spacing: any direct children get vertical rhythm */
  > * + * { margin-top: 1rem; }

  /* make buttons full-width without knowing their component ID */
  button[type="submit"] { width: 100%; }

  > .${(Field as any).styledComponentId}{
      margin: 0px 0 8px;
  };

  .logo{
    text-align: center;
  };

  form{
    margin-top: 80px;
  };
`;

const ArtPane = styled.div`
  background-image: image-set(
    url('/img/login-image.webp') type('image/webp'),
    url('/img/login-image.jpg') type('image/jpeg')
  );
  background-position: 30% center;
  background-size: cover;
  background-repeat: no-repeat;
`;

// final composed component
export default function LoginContainer({ children }: { children: React.ReactNode }) {
  return (
    <Shell>
      <Panel>
        <FormPane>
          <FormCard>{children}</FormCard>
        </FormPane>
        <ArtPane />
      </Panel>
    </Shell>
  );
}
